import { pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const PopoverContentContainer = styled.div `
  display: flex;
  flex-direction: column;
  width: ${pxToRem(320)};
  border-radius: ${themeGet('borderRadius.md')};
  border: solid ${pxToRem(1)} ${themeGet('colors.border.100')};
`;
export const Header = styled.div `
  display: flex;
  padding: ${themeGet('spacing.xl')};
  padding-right: ${themeGet('spacing.2xl')};
`;
export const Body = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${themeGet('spacing.md')};
  padding: ${themeGet('spacing.xl')};
`;
export const Footer = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${themeGet('spacing.xl')};
`;
export const Divider = styled.div `
  width: 100%;
  height: ${pxToRem(1)};
  background-color: ${themeGet('colors.background.100')};
`;
export const Description = styled.div `
  overflow: hidden;
  display: -webkit-box;
  line-height: 140%;
  line-clamp: 4;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
`;
